import { useFeatureFlags } from '#src/hooks/useFeatureFlags.tsx';

export const useEnableArcadeInbox = () => {
  const {
    flags: { arcadeInbox = false },
  } = useFeatureFlags();

  return !!arcadeInbox;
};
